module.exports = __webpack_public_path__ + "media/images/icons/v2/download-03-23c9a33d05833620704ffd714fb98d22.svg";